import { render } from "./SkipLinks.vue?vue&type=template&id=3cd47868"
import script from "./SkipLinks.vue?vue&type=script&lang=js"
export * from "./SkipLinks.vue?vue&type=script&lang=js"

import exportComponent from "/home/circleci/code/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__